import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {FmlxTab} from 'fmlx-common-ui';
import EmployeeDashbord from './EmployeeDashbord';
import ManagerDashbord from './ManagerDashbord';
import AdminDashboardInfo from './AdminDashboardInfo';

const TabItems = {
  1: 'personal',
  2: 'lead',
  3: 'admin',
};

const AdminDashbord = ({periode,currentPeriod}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const handleChange = ({index}) => {
    setSelectedTab(index);
  };

  return (
    <>
      <FmlxTab
        variant={FmlxTab.Variant.STANDARD}
        type={FmlxTab.Type.OUTLINE}
        items={Object.values(TabItems).map((title) => ({title}))}
        onChange={handleChange}
        selectedTab={selectedTab}
      />
      {selectedTab === 0 && <EmployeeDashbord periode={periode} currentPeriod={currentPeriod} />}
      {selectedTab === 1 && <ManagerDashbord periode={periode} />}
      {selectedTab === 2 && <AdminDashboardInfo periode={periode} currentPeriod={currentPeriod} />}
    </>
  );
};

AdminDashbord.propTypes = {
  periode: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default AdminDashbord;
